import React from 'react';
import { getTrackBackground, Range } from 'react-range';

import block from 'propmods';

import './AudioProgress.scss';

const b = block('AudioProgress');

interface Props {
    disabled?: boolean;
    duration: number;
    value: number;
    onChange?: (newTime: number) => void;
    onFinalChange?: (newTime: number) => void;
    trackColorActive: string;
    trackColorInactive?: string;
}

export const AudioProgress: React.FC<Props> = ({
    disabled,
    duration,
    value,
    onChange,
    onFinalChange,
    trackColorActive,
    trackColorInactive = '#919cb5',
}) => {
    return (
        <div {...b()}>
            <Range
                disabled={disabled}
                step={0.01}
                min={0}
                allowOverlap={false}
                max={duration}
                values={[value]}
                renderThumb={() => null}
                onChange={([newCurrentTime]) => onChange?.(newCurrentTime)}
                onFinalChange={([newCurrentTime]) => onFinalChange?.(newCurrentTime)}
                renderTrack={({ props: p }) => (
                    <div
                        {...b('track-container')}
                        onMouseDown={p.onMouseDown}
                        onTouchStart={p.onTouchStart}
                        style={p.style}
                    >
                        <div
                            {...b('track')}
                            ref={p.ref}
                            style={{
                                background: getTrackBackground({
                                    values: [value],
                                    colors: [trackColorActive, trackColorInactive],
                                    min: 0,
                                    max: duration,
                                }),
                            }}
                        />
                    </div>
                )}
            />
        </div>
    );
};
